import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {GenericDocCustomStatusModel} from '../../../../../../models';
import {ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config} from '../../shared';
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class InternalSalesOrderStatusService extends BaseApiTemplateService<GenericDocCustomStatusModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + Core2Config.GENERIC_DOC_PREFIX + 'custom-statuses/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + Core2Config.GENERIC_DOC_PREFIX + 'custom-statuses/backoffice-ep';
    this.httpClient = http;
  }

  uploadImage(formData: FormData, guid, visa: ApiVisa) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX
      + Core2Config.GENERIC_DOC_PREFIX + 'custom-statuses/file/' + guid + '/upload';

    if ( visa.api_domain_url) {
      url =
        visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX
        + Core2Config.GENERIC_DOC_PREFIX + 'custom-statuses/file/' + guid + '/upload';
    }
    return this.httpClient.post(url, formData, this.getHttpHeader(visa));
  }

  getPublic(visa: ApiVisa): Observable<ApiResponseModel<GenericDocCustomStatusModel>> {
    let url =  Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX
      + Core2Config.GENERIC_DOC_PREFIX + 'custom-statuses/public';

    if (visa.api_domain_url) {
      url = visa.api_domain_url +  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX
        + Core2Config.GENERIC_DOC_PREFIX + 'custom-statuses/public';
    }
    return this.httpClient.get<ApiResponseModel<GenericDocCustomStatusModel>>(this.apiUrl, this.getHttpHeader(visa));
  }

}
